import { render, staticRenderFns } from "./serve.vue?vue&type=template&id=3df820a3&"
import script from "./serve.vue?vue&type=script&lang=ts&"
export * from "./serve.vue?vue&type=script&lang=ts&"
import style0 from "./serve.vue?vue&type=style&index=0&id=3df820a3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports